import {
  validateRequired,
  validateLength,
  validateDateRange,
  validateStartDate,
  validateStartDateToday,
  validateNotNull,
} from "../../../../helpers/validationsForm";

const Inputs = (id) => {
  const isEditing = id > 0 ? true : false;
  return [
    {
      id: 1,
      name: "desc_descripcion",
      type: "text",
      label: "Nombre del Descuento",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        const lengthError = validateLength(value, { minLength: 3, maxLength: 255 }); // text puede ser largo
        if (lengthError) return lengthError;

        return null;
      },
    },
    {
      id: 2,
      label: "Porcentaje",
      name: "desc_porcentaje",
      type: "float",
      value: 0,
      placeholder: "Porcentaje de Descuento",
      validation: (value) => {
        if (value === '' || value === undefined || value === null) {
          return 'Este campo es requerido';
        }
        const num = parseFloat(value);
        if (isNaN(num) || num < 0 || num > 100) {
          return 'Debe ser un número entre 0 y 100';
        }
        return null;
      },
    },
    {
      id: 3,
      label: "Monto Mínimo de Compra",
      name: "monto_minimo",
      type: "number",
      defaultValue: 0,
      placeholder: "Ingrese el monto mínimo",
      validation: (value) => {
        if (value === '' || value === undefined || value === null) {
          return 'Este campo es requerido';
        }
        if (isNaN(Number(value))) {
          return 'Debe ser un número válido';
        }
        return null;
      },
    },
    {
      id: 4,
      label: "Monto Máximo de Compra",
      name: "monto_maximo",
      type: "number",
      defaultValue: 0,
      placeholder: "Ingrese el monto máximo",
      validation: (value) => {
        if (value === '' || value === undefined || value === null) {
          return 'Este campo es requerido';
        }
        if (isNaN(Number(value))) {
          return 'Debe ser un número válido';
        }
        return null;
      },
    },
    {
      id: 5,
      label: "Fecha de Inicio",
      name: "desc_fecha_inicio",
      type: "datetime-local",
      placeholder: "Ingrese la fecha de inicio",
      disable: isEditing,
      style: isEditing ? { backgroundColor: '#f0f0f0' } : {},

      validation: (value) => {
        if (!isEditing) {
          const requiredError = validateRequired(value);
          if (requiredError) return requiredError;

          const dateError = validateStartDateToday(value);
          if (dateError) return dateError;
        }

        return null;
      },

      cssClass: (errors, name) =>
        errors[name] ? "is-invalid" : "default-class",
    },

    {
      id: 6,
      label: "Fecha de Fin",
      name: "desc_fecha_fin",
      type: "datetime-local",
      placeholder: "Ingrese la fecha de fin",
      validation: (value, form) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateDateRange(value, form, 'desc_fecha_inicio', 'desc_fecha_fin');
      },
      cssClass: (errors, name) => (errors[name] ? 'is-invalid' : 'default-class'),
    },
    {
      id: 7,
      label: "Descuento Activo",
      name: "desc_activo",
      type: "select",
      options: [
        { value: true, label: 'Activo' },
        { value: false, label: 'Inactivo' },
      ],
      placeholder: "Seleccione estado",
      validation: (value, form) => {
        const requiredError = validateNotNull(value);
        return requiredError;
      },
    },
  ];
};

export default Inputs;
